// extracted by mini-css-extract-plugin
export default {"answer":"U--z","bestAnswerHeading":"V--z","meta":"W--z"};